import TemplateTitle from './TemplateTitle';
import TabImage from './TabImage';
import { imgGroup } from './common';
import MyCarousel from '@/components/Carousel';
import { CAROUSEL_SETTINGS } from '&/constants/index';
import SlickArrowLeft from '&/components/Carousel/SlickArrowLeft';
import SlickArrowRight from '&/components/Carousel/SlickArrowRight';
import './common.scss';
import './Template01.scss';
console.log('image', imgGroup);
export default function (props) {
    const btnList = [
        intl.get('landingPage.template1.btnMessage1'),
        intl.get('landingPage.template1.btnMessage2'),
        intl.get('landingPage.template1.btnMessage3'),
        intl.get('landingPage.template1.btnMessage4'),
        intl.get('landingPage.template1.btnMessage5'),
        intl.get('landingPage.template1.btnMessage6'),
        intl.get('landingPage.template1.btnMessage7'),
    ];
    const pics = [
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/house.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/tea.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/main.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/girl.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/boy.png')
                .default,
        },
    ];
    const smallPics = [
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/house_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/tea_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/main_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/girl_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_0/lunbo/boy_s.png')
                .default,
        },
    ];
    return (
        <div className="landing-template-one landing-template-common">
            <div className="header">
                <div className="header-title">
                    {intl.get('landingPage.template1.message1')}
                </div>
            </div>
            <section className="session-one">
                <div className="sub-content">
                    <TemplateTitle
                        title={intl.get('landingPage.template1.message2')}
                        subTitle={intl.get('landingPage.template1.message3')}
                    />
                    <TabImage btnList={btnList} imgGroup={imgGroup} />
                    <div className="arrow">
                        <img
                            src={
                                require('@/assets/img/landing/example/template_0/Arrows.png')
                                    .default
                            }></img>
                    </div>
                    <TemplateTitle
                        title={intl.get('landingPage.template1.message4')}
                        subTitle={intl.get('landingPage.template1.message5')}
                    />
                    <div className="arrow cover-img">
                        <img
                            src={
                                require('@/assets/img/landing/example/template_0/bg_2.png')
                                    .default
                            }></img>
                    </div>
                </div>
            </section>
            <section className="section-two">
                <div className="sub-content">
                    <TemplateTitle
                        title={intl.get('landingPage.template1.message6')}
                        subTitle={intl.get('landingPage.template1.message7')}
                    />
                </div>
                <div className="img-wrap">
                    <div></div>
                    <div className="hanf-img"></div>
                </div>
            </section>
            <section className="section-three">
                <div className="sub-content">
                    <TemplateTitle
                        title={intl.get('landingPage.template1.message8')}
                        subTitle=""
                    />
                    <MyCarousel
                        {...CAROUSEL_SETTINGS}
                        pics={pics}
                        imgWidth={158}
                        navGap={20}
                        dotsTotalWidth={970}
                        arrow={true}
                        selectNum={0}
                        smallPics={smallPics}
                        prevArrow={<SlickArrowLeft loop />}
                        nextArrow={<SlickArrowRight loop />}
                    />
                </div>
            </section>

            <section className="section-four">
                <div className="sub-content">
                    <div className="company-wrap">
                        <div className="title">
                            <img
                                src={
                                    require('@/assets/img/landing/logo1@2x.png')
                                        .default
                                }></img>
                            <span>
                                {intl.get('landingPage.template1.message9')}
                            </span>
                        </div>
                        <div className="desc">
                            {intl.get('landingPage.template1.message10')}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
